module.exports = "/_next/static/images/fm-2d1657d1b90eec1e16d1d5ebf4a49c08.svg";